/**
 * RailBlock — shared panel-title wrapper for bridge rail panels
 * (Wave 2, Item 1). Every rail block gets the plan §2 `.panel-title`
 * treatment: mono 10px uppercase tracking label + trailing hairline rule.
 *
 * CONSUMERS:
 * - frontend/src/pages/FleetHud.tsx: wraps NowCard / ActionRequired (left
 *   rail) and RecentRuns / FleetHealth (right rail) in bridge mode
 *
 * Chrome rules: squared corners (rounded-sm — never rounded-lg in the
 * bridge), hairline border. The content wrapper is flex-1 min-h-0 so inner
 * scroll regions inside dense panels size correctly.
 */
import React, { ReactNode } from 'react';

interface RailBlockProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export default function RailBlock({ title, children, className }: RailBlockProps) {
  return (
    <section
      className={`flex min-h-0 flex-col rounded-sm border border-white/[0.06] bg-surface${
        className ? ` ${className}` : ''
      }`}
    >
      <header className="border-b border-white/[0.06] px-3 py-2 font-mono text-[10px] uppercase tracking-[0.25em] text-text-muted">
        {title}
      </header>
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
    </section>
  );
}
